module.exports = __webpack_public_path__ + "static/media/6.jpg.2b718536.webp";